import { Box } from "@mui/joy";
import ModeToggle from "../ModeToggle";
import HatchlingReader from "./HatchlingReader";

// Simple wrapper for HatchlingReader
const HatchlingReaderWrapper = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        position: "relative",
        bgcolor: "background.body",
      }}
    >
      {/* Mode toggle in the corner */}
      <Box
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
          zIndex: 10,
        }}
      >
        <ModeToggle />
      </Box>

      {/* The actual reader component */}
      <HatchlingReader />
    </Box>
  );
};

export default HatchlingReaderWrapper;
